(() => {
  App.ui = App.ui || {};
  App.ui.popup = App.ui.popup || {};

  App.ui.popup.Type = {
    ALERT_POPUP: 'alert popup',
    DELETE_POPUP: 'delete popup',
    UNKNOWN_SERVER_ERROR: 'something went wrong',
  };

  App.ui.popup.simple = (() => {
    const popups = {
      [App.ui.popup.Type.ALERT_POPUP]: (content, properties) => {
        const genericProps = {
          className: 'dialog-window',
          alert: { ok: { text: texts('confirm@paymentPop') } },
        };
        return App.ui.popup(content, $.extend(true, genericProps, properties));
      },
      [App.ui.popup.Type.UNKNOWN_SERVER_ERROR]: (content, properties) => {
        const msg = content || texts('responseFailedInfo@emailSettingsLP');
        const genericProps = {
          className: 'dialog-window',
          alert: { ok: { text: texts('confirm@paymentPop') } },
        };
        return App.ui.popup(msg, $.extend(true, genericProps, properties));
      },
      [App.ui.popup.Type.DELETE_POPUP]: (content, properties) => {
        const genericProps = {
          className: 'dialog-window',
          confirm: {
            ok: { text: texts('delete@') },
            cancel: { text: texts('cancelText@misc') },
          },
        };
        return App.ui.popup(content, $.extend(true, genericProps, properties));
      },
    };

    return (content, properties) => {
      const { type } = properties;
      // Delete type to prevent endless redirection between popup.js and popup--simple-types.js
      // eslint-disable-next-line no-param-reassign
      delete properties.type;
      return popups[type](content, properties);
    };
  })();
})();
